import { isValidPrice } from '@domain-group/javascript-utils'

const state = {
  id: null,
  options: [],
  order_bundle_id: undefined,
  price_override: '',
  product_code: '',
  product_name: '',
  provider_id: undefined,
  provider_price_list_id: undefined,
  provider_price_list_item_id: undefined,
  publication_id: undefined,
  sort: '',
  title: '',
}

export const requiredFields = [
  { key: 'order_bundle_id' },
  { key: 'price_override', validation: (value: number | string | undefined) => (value ? isValidPrice(value) : true) },
  { key: 'title' },
]

export default state
